import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import CreateNewChatPopUp from "../../../components/CreateNewChatPopUp";
import EmptyChatFigure from "../../../assets/images/no-messages-figure.png";

const DefaultChatContainer = () => {
  const { t } = useTranslation("chat");
  const [openCreateMessage, setOpenCreateMessage] = useState(false);

  const handleCloseCreateNewChat = () => setOpenCreateMessage(false);
  const handleOpenCreateNewChat = () => setOpenCreateMessage(true);
  return (
    <Box sx={styles.container}>
      <Box src={EmptyChatFigure} component="img" sx={styles.emptyChatFigure} alt="empty-chat-figure" />
      <Typography variant="body16Regular">{t("noMessagesSendBefore")}</Typography>
      <Typography variant="body16Regular">{t("startYourChatWithYourNetwork")}</Typography>
      <Button variant="primary-sm" onClick={handleOpenCreateNewChat}>
        {t("createNewChat")}
      </Button>
      <CreateNewChatPopUp open={openCreateMessage} handleClose={handleCloseCreateNewChat} />
    </Box>
  );
};

export default DefaultChatContainer;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "24px",
  },
  emptyChatFigure: {
    width: "160px",
    height: "120px",
  },
};
